/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgArrowUpLeft(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M6.25 7A.75.75 0 017 6.25h10a.75.75 0 010 1.5H8.81l8.72 8.72a.75.75 0 11-1.06 1.06L7.75 8.81V17a.75.75 0 01-1.5 0V7z'
      />
    </svg>
  );
}

export default SvgArrowUpLeft;
